import { createContext, useState, useEffect, useContext } from "react";
import sendRequest2 from "hooks/useAxios2";
import WithAuthentication from "Authentication/AuthenticationContext.ts";
import sendRequest from "hooks/useAxios";
import toast from "react-hot-toast";

const CartItemsContext = createContext({
  shoppingData: [], //list of items
  updateCartItem: () => {},
  cartItem: () => {},
  isLoading: "",
  setIsLoading: () => {},
  productUpdater: "",
  setProductUpdater: () => {},
});
export default CartItemsContext;
export function CartItemsProvider({ children }) {
  const auth = useContext(WithAuthentication);
  const [shoppingData, setShoppingData] = useState([]);
  const [cartItemUpdater, setCartItemUpdater] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [productUpdater, setProductUpdater] = useState(false);

  const updateCartItem = () => {
    setCartItemUpdater((prev) => !prev);
  };
  useEffect(() => {
    sendRequest2("get_cart_items").then((data) => {
      setShoppingData(data.data.cart_items);
    });
  }, [cartItemUpdater]);
  const cartItem = (type, productId) => {
    setIsLoading(true);
    let temp = { product_id: productId };
    if (type == "increase") {
      temp = { ...temp, action_code: 1 };
    } else if (type == "decrease") {
      temp = { ...temp, action_code: -1 };
    }
    sendRequest("manage_cart_item", temp).then((data) => {
      if (data.data.status == 1) {
        type == "increase" &&
          toast.success("محصول با موفقیت به سبد خرید شما اضافه شد.");
        type == "decrease" &&
          toast.success("محصول با موفقیت از سبد خرید شما کم شد.");
        updateCartItem();
        setIsLoading(false);
      } else {
        type == "increase" &&
          auth.isLogged &&
          toast.error(
            "متاسفانه مشکلی درافزودن محصول به سبد خرید پیش آمده است."
          );
        type == "decrease" &&
          toast.error("متاسفانه مشکلی در کاهش محصول از سبد خرید پیش آمده است.");
        setIsLoading(false);
      }
    });
  };
  return (
    <>
      <CartItemsContext.Provider
        value={{
          shoppingData,
          updateCartItem,
          cartItem,
          isLoading,
          setIsLoading,
          productUpdater,
          setProductUpdater,
        }}
      >
        {children}
      </CartItemsContext.Provider>
    </>
  );
}
